import { useState, useCallback } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const useHandoverValidation = (formData) => {
  const { showNotification } = useNotification();
  const [errors, setErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = "";
    switch (name) {
      case 'handOverBy':
        if (!value) error = "Hand Over by is required";
        break;
      case 'takenOverBy':
        if (!value) error = "Taken Over by is required";
        break;
      case 'relatives_name':
        if (!value || !value.trim()) error = "Relatives name is required";
        break;
      case 'shiftedToWard':
        if (!value) error = "Shifted to Ward time is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  }, []);

  const validateForm = useCallback(() => {
    const requiredFields = [
      { key: 'handOverBy', label: 'Hand Over By' },
      { key: 'takenOverBy', label: 'Taken Over By' },
      { key: 'relatives_name', label: "Relative's Name" },
      { key: 'shiftedToWard', label: 'Shifted to Ward Time' },
    ];

    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '') {
        tempErrors[key] = `${label} is required`;
      }
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { 
        el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        el.focus(); 
      }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }

    return Object.keys(tempErrors).length === 0;
  }, [formData, showNotification]);

  return { errors, setErrors, validateField, validateForm };
};
